import React, { useState } from 'react'
import { AnnouncementTable, AttendanceRegularizationLogsTable, Eventtables, Importantmessagetable, Starperformancetables } from './HRActivitiesTables';
import Dashboardnavbarcopy from '../../../layout/Dashboardnavbarcopy';
import LetterBuilder from '../../DynamicBuilders/LetterBuilderManagement/LetterTemplateDisplay';
import { PopUpTable, Arreartable, Incentivetable, DynamicNaturetable, SandwichRuleTable } from './HRActivitiesTables';
import { AssetsManagement } from '../../UserDetails/Assettable';
import SlipBuilder from '../../DynamicBuilders/SlipBuilderManagement/SlipBuilderDisplay';
import InvestmentDeclarationDisplay from '../../InvestementDeclaration/InvestmentDeclarationDisplay';
import usePermission from '../../../config/permissions';


const HRActivitiesManagement = () => {
    // incomplete change back to 1
    const [toggleState, setToggleState] = useState(1);
    const emp_code = sessionStorage.getItem("emp_code")
    const { SUPER_ADMIN } = usePermission();


    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'Announcement';
            case 2:
                return 'Important message';
            case 3:
                return 'Star Performance';
            case 4:
                return 'Event';
            case 5:
                return 'Asset';
            case 6:
                return 'Letter Templates';
            case 7:
                return 'Popup Display';
            case 8:
                return 'Attendance Regularization'
            case 9:
                return 'Slip Builder'
            case 10:
                return 'Investment Declaration'
            case 11:
                return "Dynamic Nature";
            case 12:
                return "Arrear";
            case 13:
                return "Incentive";
            case 14:
                return "Sandwich Rule";
            default:
                return 'HR Activities';
        }
    };
    return (
        <>
            <div>
                <Dashboardnavbarcopy name={getSelectedTitle()} url="HR Activities" />
                <div className="bloc-tabss  wfm-margin">
                    <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(1)}
                    >
                        Information Board Announcement
                    </button>
                    <button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(2)}
                    >
                        Important message
                    </button>
                    <button
                        className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(3)}
                    >
                        Star Performance
                    </button>
                    <button
                        className={toggleState === 4 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(4)}
                    >
                        Event
                    </button>
                    <button
                        className={toggleState === 5 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(5)}
                    >
                        Asset
                    </button>
                    <button
                        className={toggleState === 6 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(6)}
                    >
                        Letter Builder
                    </button>

                    <button
                        className={toggleState === 7 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(7)}
                    >
                        Popup Display
                    </button>

                    {SUPER_ADMIN && (
                        <button
                            className={toggleState === 8 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                            onClick={() => setToggleState(8)}
                        >
                            Attendance Regularization
                        </button>
                    )}


                    {/* <button
                        className={toggleState === 9 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(9)}
                    >
                        Slip Builder
                    </button> */}
                    <button
                        className={toggleState === 10 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(10)}
                    >
                        Investment Declaration
                    </button>
                    {/* <button
                        className={toggleState === 11 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(11)}
                    >
                        Performance Management Builder
                    </button> */}

                    <button
                        className={
                            toggleState === 11
                                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs"
                                : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
                        }
                        onClick={() => setToggleState(11)}
                    >
                        Dynamic Nature
                    </button>
                    <button
                        className={
                            toggleState === 12
                                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs"
                                : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
                        }
                        onClick={() => setToggleState(12)}
                    >
                        Arrear
                    </button>
                    {/* <button
                            className={
                                toggleState === 13
                                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs"
                                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"
                            }
                            onClick={() => setToggleState(13)}
                        >
                            Incentive
                        </button> */}
                    {/* <button
                        className={toggleState === 14 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(14)}
                    >
                        Sandwich Rule
                    </button> */}

                </div>

                <div className="">

                    {toggleState === 1 ? <div className='content-tabs'><AnnouncementTable /></div> : null}

                    {toggleState === 2 ? <div className='content-tabs'><Importantmessagetable /></div> : null}

                    {toggleState === 3 ? <div className='content-tabs'><Starperformancetables /></div> : null}

                    {toggleState === 4 ? <div className='content-tabs'><Eventtables /> </div > : null}

                    {toggleState === 5 ? <AssetsManagement /> : null}

                    {toggleState === 6 ? <LetterBuilder /> : null}

                    {toggleState === 7 ? <div className='content-tabs'><PopUpTable /></div > : null}

                    {toggleState === 8 ? <div className='content-tabs'><AttendanceRegularizationLogsTable /></div > : null}

                    {toggleState === 9 ? <SlipBuilder /> : null}

                    {toggleState === 10 ? <div className='content-tabs'> <InvestmentDeclarationDisplay /> </div > : null}

                    {toggleState === 11 ? <div className='content-tabs'> <DynamicNaturetable /> </div > : null}

                    {toggleState === 12 ? <div className='content-tabs'> <Arreartable /> </div > : null}

                    {/* {toggleState === 13 ? <Incentivetable emp_code={emp_code} /> : null} */}
                    {/* {toggleState === 14 ? <div className='content-tabs'><SandwichRuleTable /></div > : null} */}
                </div >
            </div >

        </>
    )
}

export default HRActivitiesManagement
